import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { changePassword } from "@/lib/api";

export const ChangePassword = () => {
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [cf, setCf] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (nw.length < 8) { toast.error("New password must be at least 8 characters"); return; }
    if (nw !== cf) { toast.error("Passwords do not match"); return; }
    setLoading(true);
    try {
      await changePassword(cur, nw);
      toast.success("Password updated");
      setCur(""); setNw(""); setCf("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed to change password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md bg-[var(--card)] rounded-xl p-6 border border-[var(--border)]" data-testid="cms-change-password">
      <h3 className="font-serif text-xl text-[var(--burgundy)] flex items-center gap-2">
        <KeyRound className="w-5 h-5 text-[var(--gold)]" /> Change Password
      </h3>
      <p className="text-xs text-[var(--text-muted)] mt-1">Rotate your CMS password anytime — no code needed.</p>
      <form onSubmit={submit} className="mt-4 space-y-4">
        <div><Label>Current password</Label><Input type="password" value={cur} onChange={(e) => setCur(e.target.value)} className="mt-1.5" data-testid="cp-current" /></div>
        <div><Label>New password</Label><Input type="password" value={nw} onChange={(e) => setNw(e.target.value)} className="mt-1.5" data-testid="cp-new" /></div>
        <div><Label>Confirm new password</Label><Input type="password" value={cf} onChange={(e) => setCf(e.target.value)} className="mt-1.5" data-testid="cp-confirm" /></div>
        <button type="submit" disabled={loading} className="rounded-full px-6 py-2.5 text-white font-medium disabled:opacity-60" style={{ backgroundColor: "var(--gold)" }} data-testid="cp-submit">
          {loading ? "Saving..." : "Update password"}
        </button>
      </form>
    </div>
  );
};
